"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _constants = require("../utils/constants");

var _default = {
  title: 'Text Box Width (percent)',
  description: "Set the text box width in percent from the column width when on the right side or on the left side.",
  isRelevant: function isRelevant(styleParams) {
    return styleParams.isVertical && styleParams.groupSize === 1 && !styleParams.oneRow && styleParams.calculateTextBoxWidthMode === _constants.GALLERY_CONSTS.textBoxWidthCalculationOptions.PERCENT && (styleParams.allowTitle || styleParams.allowDescription);
  },
  type: _constants.INPUT_TYPES.NUMBER,
  "default": 50,
  min: 0,
  max: 100
};
exports["default"] = _default;